import {en, zhcn, symbols} from 'assets/json/l18n';

export const Languages = {
	en,
	'zh-HANS': zhcn,
	symbols,
};

export const defaultLanguage = 'en';
